import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import Plus from '@icons/Plus';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

interface Props {
    onClick: () => void;
}

/** 등록된 카드가 없을 때 보여주는 간편카드 추가 버튼. 카드 한 장과 같은 모양이다 */
function AddEasyCardRow({ onClick }: Props) {
    const { t } = useTranslation('order');
    return (
        <Container type='button' onClick={onClick}>
            <CardIcon>
                <Plus size={16} color={colors.textSecondary} />
            </CardIcon>
            <Text fontWeight='medium' color={colors.textPrimary}>{t('easyCardSheet.add')}</Text>
        </Container>
    );
}

const Container = styled.button`
    align-items: center;
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    column-gap: var(--spacing-2);
    display: flex;
    flex-shrink: 0;
    padding: var(--spacing-4);
    width: 100%;
    ${pressActionEffect}
`;

const CardIcon = styled.div`
    align-items: center;
    border: 1px dashed var(--color-border-default);
    border-radius: var(--radius-xs);
    display: flex;
    flex-shrink: 0;
    height: 40px;
    justify-content: center;
    width: 60px;
`;

export default AddEasyCardRow;
